import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaDownload, FaLinkedin, FaGithub } from 'react-icons/fa';
import './Resume.css';

const Resume: React.FC = () => {
  const handleDownload = () => {
    // The public folder is served at the root URL
    window.open('/files/UCHENNA_ANYAOHA_Resume.pdf', '_blank');
  };

  return (
    <div className="resume-container">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="resume-header"
      >
        <h1>Resume</h1>
        <p className="resume-subtitle">Professional Experience & Qualifications</p>
      </motion.div>

      <div className="resume-content">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="resume-card"
        >
          <div className="resume-card-header">
            <h2>Download Resume</h2>
            <FaDownload className="download-icon" />
          </div>
          <p>
            A condensed PDF of my resume.{' '}
            <Link to="/contact-me" style={{ color: 'inherit', textDecoration: 'underline' }}>
              Request the full version
            </Link>
          </p>
          <button onClick={handleDownload} className="download-button">
            Download PDF
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="resume-card"
        >
          <div className="resume-card-header">
            <h2>LinkedIn Profile</h2>
            <FaLinkedin className="linkedin-icon" />
          </div>
          <p>Connect with me on LinkedIn</p>
          <a
            href="https://www.linkedin.com/in/uchenna-e-anyaoha/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button linkedin"
          >
            View Profile
          </a>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="resume-card"
        >
          <div className="resume-card-header">
            <h2>GitHub</h2>
            <FaGithub className="github-icon" />
          </div>
          <p>Check out my code repositories</p>
          <a
            href="https://github.com/Anyaoha"
            target="_blank"
            rel="noopener noreferrer"
            className="social-button github"
          >
            View Profile
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.8 }}
        className="resume-preview"
      >
        <h2>Resume Preview</h2>
        <div className="preview-content">
          <div className="preview-section">
            <h3>Education</h3>
            <div className="preview-item">
              <h4>University of British Columbia</h4>
              <p>MASc. in Engineering (Data Science Inclined)</p>
              <p>2017 - 2019</p>
            </div>
          </div>

          <div className="preview-section">
            <h3>Experience</h3>
            <div className="preview-item">
              <h4>Director of AI Engineering</h4>
              <p>AI strategy, governance and team leadership</p>
            </div>
            <div className="preview-item">
              <h4>AI Engineer / LLMOps Architect</h4>
              <p>OpenTelemetry LLM observability, LLM gateway and model governance</p>
            </div>
            <div className="preview-item">
              <h4>Senior Machine Learning Engineer</h4>
              <p>Production RAG, agentic workflows and LLM evaluation</p>
            </div>
          </div>

          <div className="preview-section">
            <h3>Skills</h3>
            <div className="skills-grid">
              <span className="skill-tag">AI Strategy</span>
              <span className="skill-tag">LLMOps</span>
              <span className="skill-tag">RAG</span>
              <span className="skill-tag">Python</span>
              <span className="skill-tag">Machine Learning</span>
              <span className="skill-tag">MLflow</span>
              <span className="skill-tag">AWS SageMaker &amp; Bedrock</span>
              <span className="skill-tag">Azure OpenAI</span>
              <span className="skill-tag">Terraform</span>
              <span className="skill-tag">Data Engineering</span>
              <span className="skill-tag">Docker</span>
              <span className="skill-tag">OpenTelemetry</span>
              <span className="skill-tag">Tech Leadership</span>
              <span className="skill-tag">Entrepreneurship</span>
              <span className="skill-tag">Business Development</span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Resume; 